import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton,
  Typography
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json";
import { dateToStringDate } from "../Helpers";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const procurementTimeline = [
  {
    no: 1,
    activity: "Announcement",
    start: "March 17, 2026 00:00",
    end: "April 7, 2026 23:59",
  },
  {
    no: 2,
    activity: "Submission of Expressions of Interests (EOI)",
    start: "March 17, 2026 00:00",
    end: "April 7, 2026 12:00", // jam tetap
  },
  {
    no: 3,
    activity: "Shortlist Appointment",
    start: "April 7, 2026 00:00",
    end: "June 19, 2026 23:59",
  },
  {
    no: 4,
    activity:
      "Shortlist Announcement and Issuance of RFP (Letter of invitation to submit Proposals)",
    start: "June 22, 2026 00:00",
    end: "August 7, 2026 23:59",

  },
  {
    no: 5,
    activity: "Clarification Request Period",
    start: "June 25, 2026 00:00",
    end: "July 23, 2026 14:30", // jam tetap

  },
  {
    no: 6,
    activity: "Submission of Technical and Financial Proposals",
    start: "June 22, 2026 00:00",
    end: "August 7, 2026 12:00", // jam tetap

  },
  {
    no: 7,
    activity: "Opening of Tech Proposal",
    start: "August 7, 2026 13:00", // jam tetap
    end: "August 7, 2026 23:59",

  },
  {
    no: 8,
    activity: "Evaluation of Technical Proposals",
    start: "August 7, 2026 15:00", // jam tetap
    end: "September 14, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 9,
    activity: "Technical Rank Announcement",
    start: "September 15, 2026 00:00",
    end: "September 15, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 10,
    activity: "Opening of Financial Proposals",
    start: "September 30, 2026 00:00",
    end: "September 30, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 11,
    activity: "Evaluation of Financial Proposals",
    start: "September 30, 2026 00:00",
    end: "October 2, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 12,
    activity: "Combined Evaluation",
    start: "October 2, 2026 00:00",
    end: "October 2, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 13,
    activity: "Final Ranking",
    start: "October 5, 2026 00:00",
    end: "October 5, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 14,
    activity: "Contract Negotiation",
    start: "October 6, 2026 00:00",
    end: "October 8, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 15,
    activity: "Notification of Intention to Award",
    start: "October 21, 2026 00:00",
    end: "October 21, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 16,
    activity: "Standstill/Debriefing Period",
    start: "October 22, 2026 00:00",
    end: "November 4, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 17,
    activity: "Notification of Award",
    start: "November 5, 2026 00:00",
    end: "November 5, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
  {
    no: 18,
    activity: "Contract Signing",
    start: "November 6, 2026 00:00",
    end: "November 16, 2026 23:59",
    information: "The Evaluation of Technical Proposals is still in progress",
  },
];

function Qcqa() {
  const url_list = Config.api_domain + "/enhancement/active/";
  const [list, setList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");
        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  function getRows() {
    if (list && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/enhancement/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        {/* === KONTEN ASLI === */}
        <h2>Geospatial Capacity Enhancement</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          The purpose of implementing Geospatial Capacity Enhancement activities is as an effort to achieve positive impacts and broader benefits in the economic, social and environmental dimensions from the existence of well-managed geospatial information.

          <br></br>The objective is to enhance Indonesia's geospatial capabilities in addressing the climate crisis as part of efforts to establish the Future Geospatial Information Ecosystem through strengthening the implementation (adoption and adaptation) of the Integrated Geospatial Information Framework (IGIF).

        </p>

        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>
        <h3>Procurement Timeline</h3>
        <TableContainer component={Paper} sx={{ mb: 6 }}>
          <Table sx={{ minWidth: 500 }} aria-label="timeline table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No.</StyledTableCell>
                <StyledTableCell>Activity</StyledTableCell>
                <StyledTableCell>Start Date</StyledTableCell>
                <StyledTableCell>End Date</StyledTableCell>
                <StyledTableCell>Information</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {procurementTimeline.map((row) => (
                <StyledTableRow key={row.no}>
                  <StyledTableCell>{row.no}</StyledTableCell>
                  <StyledTableCell>{row.activity}</StyledTableCell>
                  <StyledTableCell>{row.start} (GMT+7)</StyledTableCell>
                  <StyledTableCell>{row.end} (GMT+7)</StyledTableCell>
                  <StyledTableCell>{row.information || ""}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="caption" sx={{ mt: 1, display: "block" }}>
          All schedules are based on Jakarta time (GMT +7)
        </Typography>
        <p style={{ textAlign: "justify" }}>
          The package will be processed through SPSE ICB at the link:{" "}
          <a
            href="https://spseicb.lkpp.go.id/spseicb/lelang/view/2669999"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://spseicb.lkpp.go.id/spseicb/lelang/view/2669999
          </a>

        </p>
      </Container>
    </div>
  );
}

export default Qcqa;
